import { useQuery } from '@tanstack/react-query';
import { SUPERVISOR_PRECISION_QUERY_KEY } from '../../lib/supervisorQueries';
import backend from '../../services/backend';

/** Per-check precision for the Corrections tab chips. Optional data: a failure only hides the chips. */
export function useSupervisorPrecision() {
  return useQuery({
    queryKey: SUPERVISOR_PRECISION_QUERY_KEY,
    queryFn: async () => (await backend.getSupervisorPrecision()).data,
    staleTime: 60_000,
    // The chips are optional data: a failure is silent (the backend call skips the interceptor's
    // toast, which every action's invalidation would otherwise repeat). No retry and no focus
    // refetch, so a failing route is not hammered. Not admin-gated: the route uses requireAuth() only.
    retry: false,
    refetchOnWindowFocus: false,
  });
}
